import axios from "../../axios";

const getStylists = async () => {
  try {
    const { data } = await axios.get(`/stylists?is_active[$eq]=true`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

export { getStylists };

